import styles from "./styles/contactUs.module.scss";
import { Button, FormInput, RadioButton, SecondaryButton } from "../components";
import emailjs from "@emailjs/browser";
import React, { useRef, useState } from "react";

import { ReactComponent as LinkedinLogo } from "../assets/logos/linkedin_logo.svg";
import { ReactComponent as InstagramLogo } from "../assets/logos/instagram_logo.svg";
import { ReactComponent as PhoneOutline } from "../assets/logos/phone_outline.svg";
import { ReactComponent as EmailOutline } from "../assets/logos/email_outline.svg";
import { ReactComponent as Calendly } from "../assets/logos/calendly.svg";
import { ResultBanner } from "../components/result_banner";
import { Constants } from "../keys/constants";
import Strings from "../strings/strings";

export const ContacUsSection = (className: React.HTMLAttributes<HTMLDivElement>) => {
  const form = useRef<HTMLFormElement>(null);
  const [renderBanner, setRenderBanner] = useState({
    bannerType: "",
    bannertext: "",
    render: false,
  });

  const sendEmail = (e: any) => {
    e.preventDefault();

    emailjs
      .sendForm(Constants.serviceKey, Constants.templateKeyContactUs, form.current, {
        publicKey: Constants.publicKey,
      })
      .then(
        () => {
          setRenderBanner({
            bannertext: Strings.bannerSuccess,
            bannerType: "success",
            render: true,
          });
          setTimeout(() => {
            setRenderBanner({
              bannertext: "",
              bannerType: "",
              render: false,
            });
          }, 3500);
          e.target.reset();
        },
        (error: any) => {
          setRenderBanner({
            bannertext: Strings.bannerError,
            bannerType: "failed",
            render: true,
          });
          setTimeout(() => {
            setRenderBanner({
              bannertext: "",
              bannerType: "",
              render: false,
            });
          }, 3500);
          console.warn("FAILED...", error.text);
        }
      );
  };

  return (
    <>
      {renderBanner.render === true
        ? ResultBanner({ text: renderBanner.bannertext, type: renderBanner.bannerType })
        : null}
      <div {...className}>
        <div className={styles.wrapper}>
          <div className={styles.title}>{Strings.contactUsTitle}</div>
          <div className={styles.formWrapper}>
            <div className={styles.contactInfo}>
              <div className={styles.upperFormSection}>
                <div className={styles.informationLine}>
                  <span className={styles.contactInfoTitle}>{Strings.contactInfoTitle}</span>
                </div>
                <div className={styles.informationLine}>
                  <PhoneOutline />
                  <span>{Strings.contactUsPhone}</span>
                </div>
                <div className={styles.informationLine}>
                  <EmailOutline />
                  <span>{Strings.contactUsEmail}</span>
                </div>
              </div>
              <div className={styles.logos}>
                <a
                  href="https://www.linkedin.com/company/appara-technologies-limited/?viewAsMember=true"
                  target="_Blank"
                  rel="noreferrer"
                >
                  <LinkedinLogo />
                </a>
                <a href="https://www.instagram.com/tryappara/" target="_Blank" rel="noreferrer">
                  <InstagramLogo />
                </a>
                <a
                  href="https://calendly.com/dominik-kadlubiak/call-w-appara-ceo"
                  target="_Blank"
                  rel="noreferrer"
                >
                  <Calendly />
                </a>
              </div>
            </div>
            <div className={styles.formSection}>
              <form ref={form} onSubmit={sendEmail}>
                <div className={styles.inputs}>
                  {FormInput({
                    name: "name",
                    label: Strings.contactUsNameLabel,
                    placeholder: Strings.contactUsNamePlaceholder,
                    type: "text",
                    required: true,
                  })}
                  {FormInput({
                    name: "surname",
                    label: Strings.contactUsSurnameLabel,
                    placeholder: Strings.contactUsSurnamePlaceholder,
                    type: "text",
                    required: true,
                  })}
                  {FormInput({
                    name: "email",
                    label: Strings.contactUsEmailLabel,
                    placeholder: Strings.contactUsEmailPlaceholder,
                    type: "email",
                    required: true,
                  })}
                  {FormInput({
                    name: "phone_num",
                    label: Strings.contactUsPhoneLabel,
                    placeholder: Strings.contactUsPhonePlaceholder,
                    type: "number",
                  })}
                </div>
                <div className={styles.radios}>
                  {RadioButton({ label: Strings.contactUsInquiry, name: "meeting_type" })}
                  {RadioButton({ label: Strings.contactUsMeeting, name: "meeting_type" })}
                  {RadioButton({ label: Strings.contactUsConsult, name: "meeting_type" })}
                  {RadioButton({ label: Strings.contactUsOther, name: "meeting_type" })}
                </div>
                <div className={styles.calendly}>
                  <span>{Strings.contactUsCalendly}</span>
                  <div className={styles.gap}></div>
                  {SecondaryButton({
                    text: Strings.contactUsCalendlyBtn,
                    onClick: () =>
                      window.open(
                        "https://calendly.com/dominik-kadlubiak/call-w-appara-ceo",
                        "_blank"
                      ),
                  })}
                </div>
                <div className={styles.message}>
                  {FormInput({
                    name: "message",
                    label: Strings.contactUsMessageLabel,
                    placeholder: Strings.contactUsMessagePlaceholder,
                    type: "text",
                    required: true,
                  })}
                </div>
                <div className={styles.buttonWrapper}>
                  <div className={styles.button}>
                    {Button({
                      text: Strings.contactUsSendBtn,
                      type: "submit",
                      width: "100%",
                    })}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
